import styled from '@emotion/styled';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PageContentHorizontalAlignment } from 'src/generated/webapp_gql';
import { Markdown } from 'src/modules/newPrograms/components/Markdown';
import { PageImage } from 'src/modules/newPrograms/components/PageImage';
import { ProgramPageFragment } from 'src/modules/newPrograms/documents/getProgram.generated';
import { Button } from 'src/shared/components/Button';
import { font } from 'src/shared/styles/variables';
import { HorizontalAlignmentProps } from './Page';

const Container = styled.div<HorizontalAlignmentProps>(
    {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        '.markdown': {
            p: {
                padding: '20px 0',
                fontWeight: 400,
                fontSize: font.size.medium,
            },
        },
    },
    ({ contentHorizontalAlignment }) => {
        switch (contentHorizontalAlignment) {
            case PageContentHorizontalAlignment.Start:
                return {
                    alignItems: 'flex-start',
                };
            default:
            case PageContentHorizontalAlignment.Center:
                return {
                    alignItems: 'center',
                };
        }
    },
);

interface WelcomePageProps {
    page: ProgramPageFragment;
    onClick: VoidFunction;
}

export const WelcomePage: FC<WelcomePageProps> = ({ page, onClick }) => {
    const { t } = useTranslation();

    return (
        <Container contentHorizontalAlignment={page.contentHorizontalAlignment}>
            {page.image ? <PageImage src={page.image} /> : null}
            {page.content ? (
                <Markdown
                    textHorizontalAlignment={page.contentHorizontalAlignment}
                    text={page.content}
                />
            ) : null}
            <Button type="accept" onClick={onClick} marginTop={50}>
                {t('programs:program.welcome_page.lets_begin')}
            </Button>
        </Container>
    );
};
